const kpiCards = [
  { label: "Total Revenue", value: "₹2.84M", change: "+18.2%", changeGood: true, icon: "ri-money-dollar-circle-line", iconBg: "bg-purple-50", iconColor: "text-purple-600" },
  { label: "Leads Generated", value: "847", change: "+12.5%", changeGood: true, icon: "ri-user-add-line", iconBg: "bg-blue-50", iconColor: "text-blue-600" },
  { label: "Conversion Rate", value: "18.6%", change: "-2.1%", changeGood: false, icon: "ri-line-chart-line", iconBg: "bg-amber-50", iconColor: "text-amber-600" },
  { label: "Avg Response Time", value: "2.4 hrs", change: "-15%", changeGood: true, icon: "ri-timer-flash-line", iconBg: "bg-teal-50", iconColor: "text-teal-600" },
];

export default function ReportsKPICards() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {kpiCards.map((kpi) => (
        <div key={kpi.label} className="bg-white rounded-xl border border-gray-200 p-4 flex items-start justify-between">
          <div>
            <p className="text-xs text-gray-500 uppercase tracking-wider font-medium mb-1">{kpi.label}</p>
            <p className="text-2xl font-bold text-gray-900 mb-1">{kpi.value}</p>
            <span className={`inline-flex items-center gap-0.5 text-xs font-semibold ${kpi.changeGood ? "text-green-600" : "text-red-500"}`}>
              <i className={`${kpi.changeGood ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-[10px]`} />
              {kpi.change}
            </span>
          </div>
          <div className={`w-10 h-10 rounded-lg ${kpi.iconBg} flex items-center justify-center flex-shrink-0`}>
            <i className={`${kpi.icon} ${kpi.iconColor} text-lg`} />
          </div>
        </div>
      ))}
    </div>
  );
}